import { NextPage } from "next";

import { SearchPageEntryscape } from "@/features/search/search-page/search-page-entryscape";

const SpecificationsPage: NextPage = () => (
  <SearchPageEntryscape searchType="specifications" />
);

export default SpecificationsPage;
